namespace eXpress.web.main {
	const close = () => {
		utils.writeCookie("ShowCountrySelectionPopupAgainFrom", new Date().toISOString().slice(0, 10), 365);
	};

	const showCountrySelectionPopup = () => {
		let dialog: core.StyleguideContentPopup;
		return core.StyleguideViewPopup.createDialogAsync(
			{
				view: "StyleGuideCountrySelectionDialog",
				dialogId: "country-selection",
				forceRefresh: true,
				fromCache: false
			},
			{ path : window.location.pathname }
		)
			.then($popup => {
				dialog = new core.StyleguideViewPopup($popup, { closeEvent: close });
				dialog.openAsync();
			});
	};

	eXpress.components.main.createCountrySelection({
		showCountrySelectionPopup: () => showCountrySelectionPopup(),
		close: () => close(),
	});
}
